import React, { useMemo, useState } from "react";

function entryDate(expense) {
  return new Date(expense.expense_date || expense.created_at);
}

function dateValue(date) {
  return date.toISOString().slice(0, 10);
}

function tagClass(category = "") {
  const value = category.toLowerCase();
  if (value.includes("grocery")) return "grocery";
  if (value.includes("food")) return "food";
  if (value.includes("uncategorized")) return "uncategorized";
  return "other";
}

function Transactions({ expenses, selectedMonth, onDone }) {
  const [range, setRange] = useState("month");
  const [month, setMonth] = useState(`${selectedMonth.getFullYear()}-${String(selectedMonth.getMonth() + 1).padStart(2, "0")}`);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [category, setCategory] = useState("all");
  const [paymentMethod, setPaymentMethod] = useState("all");
  const [search, setSearch] = useState("");

  const categories = [...new Set(expenses.map((expense) => expense.category || "Uncategorized"))].sort();
  const paymentMethods = [...new Set(expenses.map((expense) => expense.payment_method).filter(Boolean))].sort();
  const filteredTransactions = useMemo(() => expenses.filter((expense) => {
    const date = entryDate(expense);
    if (Number.isNaN(date.getTime())) return false;
    const formattedDate = dateValue(date);
    const inRange = range === "all" || (range === "month" && formattedDate.startsWith(month)) || (range === "custom" && (!fromDate || formattedDate >= fromDate) && (!toDate || formattedDate <= toDate));
    const matchesSearch = !search.trim() || `${expense.merchant_name} ${expense.category}`.toLowerCase().includes(search.trim().toLowerCase());
    return inRange && matchesSearch && (category === "all" || (expense.category || "Uncategorized") === category) && (paymentMethod === "all" || expense.payment_method === paymentMethod);
  }).sort((first, second) => entryDate(second) - entryDate(first)), [expenses, range, month, fromDate, toDate, category, paymentMethod, search]);

  return (
    <main className="subpage transactions-page">
      <button className="btn" onClick={onDone}>← Back to dashboard</button>
      <h1 className="subpage-title page-title-spaced">All entries</h1>
      <p className="page-intro">Search and filter your transactions.</p>
      <div className="transaction-filters">
        <select value={range} onChange={(event) => setRange(event.target.value)} aria-label="Date range"><option value="month">Selected month</option><option value="all">All time</option><option value="custom">Custom dates</option></select>
        {range === "month" && <input type="month" value={month} onChange={(event) => setMonth(event.target.value)} aria-label="Month" />}
        {range === "custom" && <><input type="date" value={fromDate} onChange={(event) => setFromDate(event.target.value)} aria-label="From date" /><input type="date" value={toDate} onChange={(event) => setToDate(event.target.value)} aria-label="To date" /></>}
        <input value={search} onChange={(event) => setSearch(event.target.value)} placeholder="Search merchant" aria-label="Search merchant" />
        <select value={category} onChange={(event) => setCategory(event.target.value)} aria-label="Category"><option value="all">All categories</option>{categories.map((item) => <option key={item} value={item}>{item}</option>)}</select>
        <select value={paymentMethod} onChange={(event) => setPaymentMethod(event.target.value)} aria-label="Payment method"><option value="all">All payment methods</option>{paymentMethods.map((item) => <option key={item} value={item}>{item}</option>)}</select>
      </div>
      <p className="transaction-count">{filteredTransactions.length} transaction{filteredTransactions.length === 1 ? "" : "s"}</p>
      {filteredTransactions.length ? <div className="ledger transaction-ledger">{filteredTransactions.map((expense) => <div className="entry" key={expense.expense_id}><div className="entry-body"><div className="entry-top"><span className="merchant">{expense.merchant_name}</span><span className="amount">₹{Number(expense.amount).toFixed(2)}</span></div><div className="entry-meta"><span className={`tag ${tagClass(expense.category)}`}>{expense.category || "Uncategorized"}</span><span className="paymethod">{expense.payment_method}</span><span className="date">{expense.expense_date}</span></div></div></div>)}</div> : <div className="empty-state">No transactions match these filters.</div>}
    </main>
  );
}

export default Transactions;
